<template>
  <div>
    <b-form-input v-model="code"></b-form-input>
    <div class="list-group overflow-auto p-1 mt-1 h-100" style="border: 1px solid rgba(0, 0, 0, 0.125); max-height: 400px;">
      <a v-for="(simulation, index) in simulations" :key="index" href="#" @click="toggleSelect(simulation)"
         class="list-group-item list-group-item-action flex-column align-items-start"
         v-bind:class="{ active: isActive(simulation) }">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ simulation.modelCode}}</h5>
          <small>{{ simulation.profile }}</small>
        </div>
        <p class="mb-1">{{ simulation.revision}}</p>
        <small>{{ simulation.dateCreated | LLT}}</small>
      </a>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner">Loading...</div>
        <div slot="no-more">No more simulation</div>
        <div slot="no-results">No results</div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
  import ModelService from '../../services/ModelService';
  import InfiniteLoading from 'vue-infinite-loading';
  import moment from 'moment';

  const modelService = ModelService.build();

  export default {
    name: "SimulationList",
    components: {
      InfiniteLoading,
    },
    props: {
      modelCode: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default: () => {
        }
      }
    },
    filters:{
      LLT: function(date) {
        return moment(date).format('L LT');
      }
    },
    computed: {
      currentSimulation: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue);
        }
      }
    },
    data() {
      return {
        simulations: [],
        infiniteId: +new Date(),
        page: 1,
        code: '',
        isFirst: true
      };
    },
    created() {
      this.code = this.modelCode;
    },

    watch: {
      code: function (val, oldVal) {
        this.changeType()
      },
      value: function (val, oldVal) {
        this.$emit('input', val)
      }
    },
    methods: {
      isActive(simulation) {
        return this.currentSimulation && this.currentSimulation.id === simulation.id
      },
      changeType() {
        this.page = 1;
        this.simulations = [];
        this.infiniteId += 1;
      },
      toggleSelect(selected) {
        if (selected !== this.currentSimulation) {
          this.currentSimulation = selected
        } else {
          this.currentSimulation = undefined
        }
      },
      async infiniteHandler($state) {
        try {
          let response = await modelService.simulations({
            modelCode: this.code,
            max: 10,
            offset: (this.page - 1) * 10,
          });
          if (response.data.length) {
            if (this.isFirst) {
              this.currentSimulation = response.data[0];
              this.isFirst = false
            }
            this.page += 1;
            this.simulations.push(...response.data);
            $state.loaded();
          } else {
            $state.complete();
          }
        } catch (e) {
          $state.complete();
          console.error(e)
        }
      },
    },
  }
</script>

<style scoped>
  .list-group-item {
    border-radius: 5px;
    margin-bottom: 2px;
  }
</style>
